import { linesConfigGlobal, setBetValueGlobal } from "../config/GlobalVariableConfig";

// import { spinResponseDataGlobal } from "../config/GlobalVariableConfig";

import { REEL_NUMBERS } from "../config/reelConfig";
import { /* customSort, */ customSortColumnWise, getCoordinates } from "../utils";
const numberUnit = 0.01; // in cents
const CASH_MULT = 0.1;
const multiplierList = [1, 2, 3, 4, 5, 10, 20, 50, 100];

export interface IMultiDetail {
    reelNum: number,
    posNum: number,
    multi: number
}

export interface WinObject { // the object -how we want to use in our program 
    lineId: number | null;
    symbolId: number;
    winAmount: number;
    winSymbolPosistions: number[][] | null;
    winMultiplier: number;
    bonusWon: string;
}

export interface IShutterFeatureData {
    shutterType: string;
    shutterPosition: number[][];
    startCash: number;
    addedCash?: number[][];
    collectedCash?: number;
}

export interface IFeatureData {
    featureName: string;
    revealedSymbols: number[][];
    revealedMultiplierSymPos: number[][];
    revealedShutterSymPos: number[][];
    revealedMultipliers: number[][];
    totalFeatureWinAmount: number;
    shutterFeature: IShutterFeatureData[] | null;
    highlightPositions: number[][];
}

export interface RespinObject { // the object -how we want to use in our program 

    type: string;
    freeGameTrigger: number;
    reelSymbols: number[][];
    finalMult: number[][];
    winLines: WinObject[] | null; // Making winLines optional because might be no win
    winScatters: WinObject[] | null;
    winAmount: number; // win of that particular cascade respin 
    multiplier: number; // accumulated multiplier applicable on  that particular respin 
    accumulatedsWinAmount: number; // win of that particular respin total
    cascadePositions: number[][];

    // gameMultipliers: number[];
    featureInitMultipliers: number[];
    featureData?: IFeatureData;

    isWinHigherBet: boolean;
    initMultiplers: IMultiDetail[]
    newMultiplers: IMultiDetail[];
    highlights: number[][];
    feature: string;
    highlightedMultipliers: IMultiDetail[];
    sumHighLightedMulti: IMultiDetail[];
    removeMulti: IMultiDetail[];
}

export interface SpinDataObject { // the object -how we want to use in our program 

    dataFeatched: boolean;

    betAmount: number;

    // state value - kind of header
    freeGameTrigger: number; // number of fs won in base game
    freeGameReTrigger: number;  // number of fs won in free game
    totalFreeGame: number; // total number of fs - to show in counter 
    remainingFreeGame: number; // remaining number of fs - to show in counter 
    totalAccumulatedWin: number; // used specially in free games
    totalWin: number;  // win of current spin including all respins
    balance: number;


    respins: RespinObject[];

};



export const spinData: SpinDataObject = { // use in other class

    dataFeatched: false,

    betAmount: 0,
    freeGameTrigger: 0,
    freeGameReTrigger: 0,
    totalFreeGame: 0,
    remainingFreeGame: 0,
    totalAccumulatedWin: 0,
    totalWin: 0,
    balance: 0,
    respins: []
};

export function resetSpinData(): void {
    spinData.dataFeatched = false;

    spinData.freeGameTrigger = 0;
    spinData.freeGameReTrigger = 0;
    spinData.totalFreeGame = 0;
    spinData.remainingFreeGame = 0;
    spinData.totalAccumulatedWin = 0;
    spinData.totalWin = 0;
    spinData.balance = 0;

    spinData.respins = [];
}


// export async function spinResponse(): Promise<void> {

//     console.log('insidespinResponse');

//     parserSpinResponse(spinResponseDataGlobal);

// }



export function parserSpinResponse(data: any): void {
    console.log("inside parserSpinResponse", data);



    // Initialize the SpinDataObject
    spinData.dataFeatched = true;

    spinData.betAmount = Number(data.betAmountString) / 100;
    setBetValueGlobal(spinData.betAmount);
    let highlightPositions: number[][] = [];
    let fsWindmillRevealTriggered: boolean = false;


    data.events.forEach((event: any) => {
        if (fsWindmillRevealTriggered) {
            highlightPositions = [];
            fsWindmillRevealTriggered = false;
        }
        let isWinHigherBet = false;
        if (Number(event.wa / 100) > Number(spinData.betAmount)) {
            isWinHigherBet = true;
        } else {
            isWinHigherBet = false;
        }

        // Each spin will be treated as a respin
        const reelSymbols: number[][] = (event.c && event.c.grid) ? decodeGrid(event.c.grid) : [];
        // console.log(reelSymbols);

        let respinWinAmount = Number((event.wa * numberUnit).toFixed(2)); // Total win of that particular respin
        // console.log(winAmount);

        let accumWinAmount = Number((event.awa * numberUnit).toFixed(2)); // Total win of that particular respin

        let totalMultiplier = 1;

        const type = event.etn;

        // // Check for feature spin (e.g., free game trigger)
        let freeGameTrigger = 0;
        if (event.etn === "feature_enter") {
            freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.totalFreeGame = Number(event.c.bonusFeatureCount) || 0;
        }

        const winLines: WinObject[] = [];
        const winScatters: WinObject[] = [];
        const cascadePositions: number[][] = [];



        // const gameMultipliers: number[] = [];
        const featureInitMultipliers: number[] = [];

        let finalMult: number[][] = [];
        let initMultipliers: IMultiDetail[] = [];
        let newMultipliers: IMultiDetail[] = [];
        let highlights: number[][] = [];
        let feature: string = "";
        let highlightedMultipliers: IMultiDetail[] = [];
        let sumHighLightedMulti: IMultiDetail[] = [];
        let removeMulti: IMultiDetail[] = [];

        event.c && event.c.actions?.forEach((action: any, index: number) => {
            if (action.at === "initialMultipliers" || action.at === "multiplierIncrease") { // Handling wild multiplier
                if (index != 0) {
                    featureInitMultipliers.push(Number(action.data.m));
                    const length = action.data.queue.length;
                    if (length > 0) {
                        for (let i = 0; i < length; i++) {
                            featureInitMultipliers.push(Number(action.data.queue[i]));
                        }
                    }

                } else {
                    // gameMultipliers.push(Number(action.data.m));
                    const length = action.data.queue.length;
                    if (length > 0) {
                        for (let i = 0; i < length; i++) {
                            // gameMultipliers.push(Number(action.data.queue[i]));
                        }
                    }
                }
            }
            else if (action.at === "gridwin") { // Handling win lines or win scatters
                const symbolId = Number(action.data.symbol);
                //const lineId = Number(action.data.lineId) || null;
                const winAmount = Number(action.data.winAmount * numberUnit);
                const winSymbolPositions = action.data.mask ? getReelPositions(action.data.mask) : [];
                const winMultiplier = action.data.winMultipliers ? Number(getTheTotalMultiplier(action.data.winMultipliers)) : 1;
                const bonusWon = action.data.bonusWon || ""; // Assuming you want to track bonus wins

                const count = Number(action.data.count)
                const lineId = getLineId(winSymbolPositions, count);

                const winObject: WinObject = {
                    lineId,
                    symbolId,
                    winAmount,
                    winSymbolPosistions: winSymbolPositions.length > 0 ? winSymbolPositions : null,
                    winMultiplier,
                    bonusWon
                };

                if (symbolId === 12) { // Assuming symbol 12 is a scatter
                    winScatters.push(winObject);
                } else {
                    winLines.push(winObject);
                }
            }
            else if (action.at === "highlight") { // Handling highlight positions
                highlightPositions = [];
                action.data.mask ? getReelPositions(action.data.mask) : [];
                const mask = action.data.h; // Mask as string of 0s and 1s

                if (mask.length > 0) {
                    for (let i = 0; i < mask.length; i++) {
                        if (mask[i] === '1') { // Only process positions marked as '1'
                            const position: [number, number] = [
                                i % REEL_NUMBERS,               // Reel Number
                                Math.floor(i / REEL_NUMBERS)    // Position
                            ];
                            highlightPositions.push(position);
                        }
                    }
                }
            }
            else if (action.at === "remove") { // Handling wild multiplier

                action.data.mask ? getReelPositions(action.data.mask) : [];
                const mask = action.data.mask; // Mask as string of 0s and 1s

                if (mask.length > 0) {
                    for (let i = 0; i < mask.length; i++) {
                        if (mask[i] === '1') { // Only process positions marked as '1'
                            const position: [number, number] = [
                                i % REEL_NUMBERS,               // Reel Number
                                Math.floor(i / REEL_NUMBERS)    // Position
                            ];
                            cascadePositions.push(position);
                        }
                    }
                }
            }
            else if (action.at === "retrigger") { // Handling win lines or win scatters
                const symbolId = 12; // Assuming symbol 12 is a scatter
                const lineId = 0;
                const winAmount = 0;
                const winSymbolPositions = action.data.h ? getReelPositions(action.data.h) : [];
                const winMultiplier = 0;
                const bonusWon = ""; // Assuming you want to track bonus wins

                const winObject: WinObject = {
                    lineId,
                    symbolId,
                    winAmount,
                    winSymbolPosistions: winSymbolPositions.length > 0 ? winSymbolPositions : null,
                    winMultiplier,
                    bonusWon
                };

                winScatters.push(winObject);

                freeGameTrigger = Number(action.data.s);

            }
            else if (action.at === "newMultipliers") {// Handling new multipliers
                initMultipliers = getMultipliersWithDetails(action.data.m);
                newMultipliers = getNewMultipliersWithDetails(action.data.p, action.data.newMultipliers);
                //const positions = action.data.p;
                //const newMultipliers = action.data.newMultipliers;
            }
            else if (action.at === "crossFireRows") {// Handling new multipliers
                feature = "crossFireRows";
                highlights = getReelPositions(action.data.h);
            }
            else if (action.at === "showdownReels") {// Handling new multipliers
                feature = "showdownReels";
                highlights = getReelPositions(action.data.h);
            }
            else if (action.at === "ricochetShots") {// Handling new multipliers
                feature = "ricochetShots";
                highlights = getReelPositions(action.data.h);
            }
            else if (action.at === "highlightedMultipliers") {// Handling new multipliers
                highlightedMultipliers = getMultipliersWithDetails(action.data.m);
            }
            else if (action.at === "sumHighlightedMultipliersWithCurrentMultipliers") {// Handling new multipliers
                sumHighLightedMulti = getMultipliersWithDetails(action.data.m);
            }
            else if (action.at === "removedMultipliersOnWinningPositions") {// Handling new multipliers
                removeMulti = getNewMultipliersWithDetails(action.data.p, action.data.m);
            }
        });

        let featureData: IFeatureData
        featureData = {
            highlightPositions: highlightPositions,
            featureName: "",
            revealedSymbols: [],
            revealedMultiplierSymPos: [],
            revealedShutterSymPos: [],
            revealedMultipliers: [],
            totalFeatureWinAmount: 0,
            shutterFeature: null,
        }

        if (event.etn === "windmill_reveal" || event.etn === "fs_windmill_reveal") {
            let shutterFeatureDataCollection: IShutterFeatureData[] = [];
            let featureWin = 0;
            let revealedPos: number[][] = [];
            let revealedMulPos: number[][] = [];
            let revealedShutterPos: number[][] = [];
            let revealedMultipliers: number[][] = [];

            event.c && event.c.actions?.forEach((action: any) => {
                if (action.at.toLowerCase().includes("shutter")) {
                    let shutterData: IShutterFeatureData = {
                        shutterType: action.at,
                        shutterPosition: [[getCoordinates(action.data.p).col, getCoordinates(action.data.p).row]],
                        startCash: Number(action.data.startCash * CASH_MULT),
                        addedCash: (action.data.addedCash) ? getIn2DPositions(action.data.addedCash) : undefined,
                        collectedCash: (action.data.collectedCash) ? action.data.collectedCash * CASH_MULT : undefined
                    }
                    shutterFeatureDataCollection.push(shutterData);
                }

                if (action.at === "cashWin") {
                    featureWin = Number(action.data.w) * numberUnit;
                }
            });

            const reelSymbols: number[][] = (event.c && event.c.grid) ? decodeGrid(event.c.grid) : [];

            for (let i = 0; i < reelSymbols.length; i++) {
                revealedMultipliers[i] = [];
                for (let j = 0; j < reelSymbols[i].length; j++) {
                    revealedMultipliers[i][j] = (reelSymbols[i][j] > 14) ? (multiplierList[(reelSymbols[i][j] - 14) - 1]) : 0;
                    if (reelSymbols[i][j] === 14) {
                        revealedShutterPos.push([i, j]);
                        revealedPos.push([i, j]);
                    } else if (reelSymbols[i][j] > 14) {
                        revealedMulPos.push([i, j]);
                        revealedPos.push([i, j]);
                    }
                }
            }

            revealedShutterPos = customSortColumnWise(revealedShutterPos);
            revealedPos = customSortColumnWise(revealedPos);

            featureData = {
                featureName: "windmill_reveal",
                revealedSymbols: revealedPos,
                revealedMultiplierSymPos: revealedMulPos,
                revealedShutterSymPos: revealedShutterPos,
                revealedMultipliers: revealedMultipliers,
                totalFeatureWinAmount: featureWin,
                shutterFeature: shutterFeatureDataCollection,
                highlightPositions: highlightPositions,
            }
        }
        // Create the RespinObject and push it to spinData.respins
        const respin: RespinObject = {
            type: type,
            freeGameTrigger: freeGameTrigger,
            reelSymbols: reelSymbols,
            finalMult: finalMult,
            winLines: winLines.length > 0 ? winLines : null,
            winScatters: winScatters.length > 0 ? winScatters : null,
            winAmount: respinWinAmount,
            cascadePositions: cascadePositions,
            multiplier: totalMultiplier,
            accumulatedsWinAmount: accumWinAmount,
            // gameMultipliers: gameMultipliers,
            featureInitMultipliers: featureInitMultipliers,
            isWinHigherBet: isWinHigherBet,
            featureData: featureData,
            initMultiplers: initMultipliers,
            newMultiplers: newMultipliers,
            highlights: highlights,
            feature: feature,
            highlightedMultipliers: highlightedMultipliers,
            sumHighLightedMulti: sumHighLightedMulti,
            removeMulti: removeMulti
        };

        spinData.respins.push(respin);
        if (event.etn === "fs_windmill_reveal")
            fsWindmillRevealTriggered = true;

    });

    console.log("Parsed spin data:", spinData);

}

function getTheTotalMultiplier(multis: string[]): number {
    let total: number = 0;
    multis.forEach((item) => { total += Number(item); });
    return total;

}
function decodeGrid(grid: string): number[][] {
    const offset = 40; // ASCII offset for encoding

    // Extract width and height from the first two characters
    const width = grid.charCodeAt(0) - offset;
    const height = grid.charCodeAt(1) - offset;

    // Initialize the 2D array for storing the grid
    const gridArray = [];

    // Populate the 2D array with decoded values
    let index = 2; // Start from the third character
    for (let row = 0; row < height; row++) {
        const currentRow = [];
        for (let col = 0; col < width; col++) {
            // Convert each character to its decimal value using the offset
            const cellValue = grid.charCodeAt(index) - offset;
            currentRow.push(cellValue);
            index++;
        }
        gridArray.push(currentRow);
    }


    // console.log(gridArray);

    // Transpose the 2D array (swap rows with columns)
    const transposedArray = transposeMatrix(gridArray);

    // function to transpose a matrix (2D array)
    function transposeMatrix(matrix: number[][]) {
        return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    }

    return transposedArray;

}

function getMultipliersWithDetails(multipliers: string[]): IMultiDetail[] {

    // const rows = Math.ceil(binaryString.length / REEL_NUMBERS);
    const result: IMultiDetail[] = [];

    // Loop through the binary string and fill the 2D array conceptually
    for (let i = 0; i < multipliers.length; i++) {
        const m = Number(multipliers[i])
        const reelId = i % REEL_NUMBERS;          // Column number (reelId)
        const positionNum = Math.floor(i / REEL_NUMBERS); // Row number (position)
        result.push({ reelNum: reelId, posNum: positionNum, multi: m });
    }
    return result;
}

function getNewMultipliersWithDetails(positions: string[], multipliers: string[]): IMultiDetail[] {

    // const rows = Math.ceil(binaryString.length / REEL_NUMBERS);
    const result: IMultiDetail[] = [];

    // Loop through the binary string and fill the 2D array conceptually
    for (let i = 0; i < positions.length; i++) {
        const p = Number(positions[i])
        const reelId = p % REEL_NUMBERS;          // Column number (reelId)
        const positionNum = Math.floor(p / REEL_NUMBERS); // Row number (position)
        const m = Number(multipliers[i]);
        result.push({ reelNum: reelId, posNum: positionNum, multi: m });
    }
    return result;
}

function getIn2DPositions(data: string[], columns: number = 5): number[][] {
    let arr: number[][] = [];
    for (let i = 0; i < data.length; i++) {
        const val = Number(data[i]) * CASH_MULT;
        const row = Math.floor(i / columns);
        const col = (i % columns);
        arr[col] = arr[col] || [];
        arr[col][row] = val;
    }
    return arr;
}

function getLineId(winSymbolPositions: number[][], count: number): number | null {
    // Create an array to represent the line structure from winSymbolPositions
    const positionsByReel: number[] = [];

    for (let i = 0; i < winSymbolPositions.length; i++) {
        const [reel, pos] = winSymbolPositions[i];
        positionsByReel[reel] = pos;
    }

    // Compare with each line in linesConfigGlobal
    for (let lineIndex = 0; lineIndex < linesConfigGlobal.length; lineIndex++) {
        const lineConfig = linesConfigGlobal[lineIndex];


        let match = true;
        for (let reel = 0; reel < count; reel++) {
            if (positionsByReel[reel] !== lineConfig[reel]) {
                match = false;
                break;
            }
        }

        if (match) return lineIndex;
    }

    return null; // No match found
}

function getReelPositions(binaryString: string): [number, number][] {

    // const rows = Math.ceil(binaryString.length / REEL_NUMBERS);
    const result: [number, number][] = [];

    // Loop through the binary string and fill the 2D array conceptually
    for (let i = 0; i < binaryString.length; i++) {
        const reelId = i % REEL_NUMBERS;          // Column number (reelId)
        const positionNum = Math.floor(i / REEL_NUMBERS); // Row number (position)

        if (binaryString[i] === '1') {
            result.push([reelId, positionNum]);
        }
    }

    return result;
}